import { createStore } from 'zustand'

import { LoginType } from '../enums/LoginType'

import { LoginStore } from './interface'

export const loginStore = createStore<LoginStore>((set, get) => ({
  loginType: LoginType.WECHAT,
  setLoginType(type) {
    set({ loginType: type })
  }
}))
